<template>
  <section class="quiz-section">
    <b-container class="h-100">
      <div class="quiz-wrapper">
        <div class="">
          <AppSidebar>
            <section class="sidebar-section">
              <div class="sidebar-title-wrapper">
                <h4>
                  {{ lessonDetail.lessonName }}
                </h4>
              </div>
              <div class="sidebar-content">
                <div
                  class="sidebar-content-wrapper"
                  :key="`lesson${index}`"
                  v-for="(lesson, index) in lessonDetail.list"
                >
                  <div class="title-wrapper">
                    <div>
                      <span class="lesson-icon" v-if="lesson.videoLength">
                      <!--   logo as per content type     -->
                        <svg
                            width="15"
                            height="14"
                            viewBox="0 0 15 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_83_13655)">
                            <path
                                d="M6.0874 10.1892V3.88922L11.2296 7.0392L6.0874 10.1892Z"
                                fill="#a6a8ac"
                            />
                            <path
                                d="M6.0874 10.1892L11.2296 7.0392L6.0874 3.88922V10.1892Z"
                                fill="#a6a8ac"
                            />
                            <path
                                d="M7.53076 0C5.67422 0 3.89379 0.737495 2.58105 2.05029C1.26826 3.36298 0.530762 5.14351 0.530762 7C0.530762 8.85649 1.26826 10.637 2.58105 11.9497C3.89374 13.2625 5.67427 14 7.53076 14C9.38725 14 11.1677 13.2625 12.4805 11.9497C13.7933 10.637 14.5308 8.85649 14.5308 7C14.5308 5.14351 13.7933 3.36303 12.4805 2.05029C11.1678 0.737495 9.38725 0 7.53076 0ZM7.53076 13.0199C5.9342 13.0199 4.40303 12.3856 3.27404 11.2566C2.14505 10.1278 1.51078 8.59641 1.51078 6.99992C1.51078 5.40344 2.14505 3.8722 3.27404 2.74321C4.40293 1.61421 5.93427 0.979943 7.53076 0.979943C9.12725 0.979943 10.6585 1.61421 11.7875 2.74321C12.9165 3.8721 13.5507 5.40344 13.5507 6.99992C13.5507 8.59641 12.9165 10.1277 11.7875 11.2566C10.6586 12.3856 9.12725 13.0199 7.53076 13.0199Z"
                                fill="#a6a8ac"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_83_13655">
                              <rect
                                  width="14"
                                  height="14"
                                  fill="#a6a8ac"
                                  transform="translate(0.530762)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                       </span>
                      <span class="lesson-icon" v-else>
                      <!--   logo as per content type     -->
                        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8.64011 1.21875H2.62893C1.91753 1.21875 1.34082 1.7644 1.34082 2.4375V10.5625C1.34082 11.2356 1.91753 11.7812 2.62893 11.7812H8.64011C9.35151 11.7812 9.92822 11.2356 9.92822 10.5625V2.4375C9.92822 1.7644 9.35151 1.21875 8.64011 1.21875Z" stroke="#a6a8ac" stroke-linejoin="round"/>
                          <path d="M3.4873 3.25H7.781" stroke="#a6a8ac" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M3.4873 5.28125H7.781" stroke="#a6a8ac" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M3.4873 7.3125H5.63415" stroke="#a6a8ac" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                       </span>
                    </div>
                    <div>
                      <div class="content-title">
                        <a class="lesson-title"
                           :href="`${appRedirectLink}classroomcategory/${lessonDetail.lessonSlug}`"
                        >
                          <span >{{ lesson.title }}</span>
                        </a>
                      </div>
                      <div class="content-subtitle" v-if="lesson.videoLength">
                        {{ lesson.videoLength }} min
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </AppSidebar>
        </div>
        <div class="content">
          <div class="title-wrapper">
            <div>
              <h4>{{ quiz.name }}</h4>
            </div>
            <div>
              <div class="timer">
                Time Remaining: <span>{{ currentTime }}</span>
              </div>
            </div>
          </div>
          <div class="questions-card-wrapper" v-if="!isLoading">
            <div
              class="question-card"
              :key="`questionKey${index}`"
              v-for="(question, index) in quiz.questions"
            >
              <div class="question">
                {{ index + 1 }}. {{ question.question.questionText }}
              </div>
              <div class="answer-options">
                <div
                  class="option-wrapper"
                  :key="`option${index}${optionIndex}`"
                  v-for="(option, optionIndex) in question.question.options"
                >
                  <div>
                    <input
                      :type="type[question.question.type]"
                      v-model="question.question.selected"
                      :value="option"
                      :name="
                        type[question.question.type] === 'radio'
                          ? `question${index + 1}`
                          : ''
                      "
                      :id="`option${index}${optionIndex}`"
                    />
                  </div>
                  <div>
                    <label :for="`option${index}${optionIndex}`">{{
                      option
                    }}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="question-action">
              <b-btn class="btn-yellow" @click="calculateScore(submit)" pill
                >Submit</b-btn
              >
            </div>
          </div>
        </div>
      </div>
      <b-modal
        id="bv-modal-score"
        @close="modalClosed()"
        centered
        no-close-on-backdrop
        hide-footer
      >
        <template #modal-title>
          <div class="text-center w-100">
            <h4>
              <b>{{ pass ? "Well Done" : "You were so close!" }}</b>
            </h4>
          </div>
        </template>
        <div class="text-center mb-3">
          <img
            :src="
              pass
                ? require('@/assets/img/logo.svg')
                : require('@/assets/img/failure.svg')
            "
            alt=""
          />
        </div>
        <div class="text-center mb-3" v-if="pass">
          <h2 class="mb-3">
            <b>+ {{ quiz.reward }}</b>
          </h2>
          <h6>You have earned {{ quiz.reward }} Points.</h6>
          <!--          <h6 style="text-decoration: underline;" class="cursor-pointer">Claim Reward</h6>-->
        </div>
        <div class="text-center" v-if="!pass">
          <div class="mb-3">
            <h2
              style="text-decoration: underline"
              @click="reloadQuiz"
              class="cursor-pointer"
            >
              <b>Retake quiz?</b>
            </h2>
          </div>
          <!--          <div class=" mb-3">
            <h4 style="text-decoration: underline;"
                class="cursor-pointer"><b>Move to Next Module</b></h4>
          </div>-->
        </div>
        <!--        <b-button class="mt-3" block @click="modalClosed">Close</b-button>-->
      </b-modal>
    </b-container>
  </section>
</template>

<script>
import AppSidebar from "../components/AppSidebar";
import { QuizService } from "../data/services/quiz.service";
import { secondsToMinSec } from "../utils/utils";

function multipleExist(arr, values) {
  return values.every((value) => {
    return arr.includes(value);
  });
}

export default {
  name: "Quiz",
  components: { AppSidebar },
  data() {
    return {
      appRedirectLink: process.env.VUE_APP_ROOT_LINK,
      type: {
        single: "radio",
        multiple: "checkbox",
      },
      isLoading: true,
      quiz: null,
      lessonDetail: null,
      pass: false,
      time: 10 * 60,
      timer: null,
    };
  },
  computed: {
    slug() {
      return this.$route.params.slug ? this.$route.params.slug : null;
    },
    currentTime() {
      return secondsToMinSec(this.time);
    },
  },
  watch: {
    time(value) {
      if (value < 1) {
        this.pass = false;
        this.$bvModal.show("bv-modal-score");
      }
    },
  },
  mounted() {
    this.getQuiz().then(() => this.startTimer());
  },
  beforeDestroy() {
    this.stopTimer();
  },
  methods: {
    startTimer() {
      this.stopTimer();
      this.timer = setInterval(() => {
        this.time = this.time - 1;
        if (this.time <= 0) {
          this.stopTimer();
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timer !== null) {
        clearInterval(this.timer);
      }
    },
    async getQuiz() {
      this.isLoading = true;
      const quizService = new QuizService();
      await quizService
        .getQuiz(this.slug)
        .then((response) => {
          console.log("response === ", response);
          this.quiz = response.quiz;
          this.lessonDetail = response.lessonDetail;
          this.isLoading = false;
        })
        .catch((e) => {
          console.log("err => ", e);
        });
    },
    calculateScore(callback) {
      // const request = {
      //   score: 0
      // }
      this.quiz.myScore = 0;
      this.quiz.questions.forEach((question) => {
        console.log("calculate question ", question);
        if (question.question.type === "single") {
          if (question.question.solution.includes(question.question.selected)) {
            this.quiz.myScore = this.quiz.myScore + question.score;
          }
        } else if (question.question.type === "multiple") {
          // if ()
          console.log("multiple check");
          console.log("multiple exist", question.question.solution);
          console.log("multiple exist", question.question.selected);
          console.log(
            "multiple exist",
            multipleExist(
              question.question.solution,
              question.question.selected
            )
          );
          if (
            multipleExist(
              question.question.solution,
              question.question.selected
            )
          ) {
            this.quiz.myScore = this.quiz.myScore + question.score;
          }
        }
      });
      callback();
    },
    async submit() {
      // this.isLoading = true
      const quizService = new QuizService();
      await quizService
        .submitQuiz(this.quiz)
        .then((response) => {
          if (response.pass) {
            // notify pass
            console.log("passed");
            this.pass = true;
          } else {
            this.pass = false;
            console.log("failed");
          }
          this.$bvModal.show("bv-modal-score");
        })
        .catch(() => {
          // this.quiz.myScore = 0
        });
    },
    openLessonRoute(lesson) {
      const url = `${this.appRedirectLink}classroomcategory/${lesson.slug}/`;
      console.log("lesson url", url);
      // todo link route to lesson slug
      window.open(url, "_self");
    },
    modalClosed() {
      // this.$bvModal.hide('bv-modal-score')
      this.$router.push("/account");
    },
    reloadQuiz() {
      window.location.reload();
    },
  },
};
</script>

<style lang="scss" scoped>
.quiz-section {
  //position: relative;
  //top: 132px;
  margin-bottom: 94px;
  padding: 30px 0 80px 0;

  .quiz-wrapper {
    margin: 20px 0;
    display: flex;
    .sidebar-section {
      .lesson-icon {
        position: relative;
        top: -3px;
      }
      .sidebar-title-wrapper {
        display: flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        margin-bottom: 28px;

        h4 {
          color: #fff;
          font-weight: 700;
          font-size: 18px;
          line-height: 25px;
          text-decoration: none;
          text-shadow: none;
        }

        .timer {
          width: max-content;
        }
      }

      .sidebar-content {
        .sidebar-content-wrapper {
          margin-bottom: 28px;

          .title-wrapper {
            display: flex;
            gap: 10px;
          }

          .content-title {
            a {
              color: unset;
              &:hover {
                text-decoration: none;
              }
            }
            cursor: pointer;
            color: #a6a8ac;
            font-size: 16px;
            line-height: 22px;
            &:hover {
              //color: #fff;
            }
          }
          .content-subtitle {
            color: #f1bc04;
            font-size: 16px;
            line-height: 22px;
            letter-spacing: 0.05em;
          }
        }
      }
    }

    .content {
      background-color: #f8f8f8;
      padding: 42px 46px;
      //height: 50vh;
      width: 100%;

      .title-wrapper {
        display: flex;
        justify-content: space-between;
        -webkit-justify-content: space-between;
        align-items: baseline;
        margin-bottom: 28px;

        h4 {
          color: #000000;
          font-size: 22px;
          font-weight: 700;
          line-height: 32px;
        }
      }

      .questions-card-wrapper {
        .question-card {
          margin-bottom: 26px;
          padding: 20px 26px;
          background: #ffffff;
          border-radius: 20px;

          .question {
            margin-bottom: 12px;
          }
          .answer-options {
            padding-left: 18px;

            .option-wrapper {
              margin-bottom: 4px;
              display: flex;
              //gap: 4px;

              input {
                margin: 0;
              }
              label {
                margin: 0;
                margin-left: 12px;
              }
            }
          }
        }

        .btn-yellow {
          background: #f1bc04;
          border-color: #f1bc04;
          border-radius: 45px;
        }
      }
    }
  }
}
@media (max-width: 475px) {
  .quiz-section {
    margin-bottom: 15px;
    padding: 0;
    .quiz-wrapper {
      margin: 10px 0;
      flex-direction: column;
      gap: 20px;

      .sidebar-section {
        .lesson-icon {
          top: -3px;
        }
        .sidebar-title-wrapper {
          display: flex;
          justify-content: space-between;
          -webkit-justify-content: space-between;
          margin-bottom: 15px;

          h4 {
            font-weight: 700;
            font-size: 14px;
            line-height: 18px;
          }

          .timer {
          }
        }

        .sidebar-content {
          .sidebar-content-wrapper {
            margin-bottom: 16px;

            .title-wrapper {
              flex-direction: row!important;
              gap: 8px!important;
            }

            .content-title {
              a {
                &:hover {
                }
              }
              cursor: pointer;
              color: #a6a8ac;
              font-size: 11px;
              line-height: 16px;
              &:hover {
                //color: #fff;
              }
            }
            .content-subtitle {
              color: #f1bc04;
              font-size: 11px;
              line-height: 16px;
              letter-spacing: 0.05em;
            }
          }
        }
      }

      .content {
        padding: 14px 10px!important;
      }
      .title-wrapper {
        display: flex!important;
        flex-direction: column!important;
        margin-bottom: 15px!important;
        h1 {
          font-size: 14px!important;
        }
        .timer {
          font-size: 12px!important;
        }
      }

      .questions-card-wrapper {
        .question-card {
          margin-bottom: 16px!important;
          padding: 10px 16px!important;
          border-radius: 16px!important;
          font-size: 11px!important;

          .question {
            margin-bottom: 8px!important;
          }
          .answer-options {
            padding-left: 10px!important;

            .option-wrapper {
              margin-bottom: 4px!important;
              display: flex!important;
              //gap: 4px;

              input {
                margin: 0;
              }
              label {
                margin: 0;
                margin-left: 8px;
              }
            }
          }
        }

        .btn-yellow {
          background: #f1bc04;
          border-color: #f1bc04;
          border-radius: 35px;
          font-size: 11px;
        }
      }
    }
  }
}
</style>
